<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M11.25 18C11.25 17.6562 11.1276 17.362 10.8828 17.1172C10.638 16.8724 10.3438 16.75 10 16.75C9.65625 16.75 9.36198 16.8724 9.11719 17.1172C8.8724 17.362 8.75 17.6562 8.75 18C8.75 18.3438 8.8724 18.638 9.11719 18.8828C9.36198 19.1276 9.65625 19.25 10 19.25C10.3438 19.25 10.638 19.1276 10.8828 18.8828C11.1276 18.638 11.25 18.3438 11.25 18ZM14.5 15.5V4.5C14.5 4.36458 14.4505 4.2474 14.3516 4.14844C14.2526 4.04948 14.1354 4 14 4H6C5.86458 4 5.7474 4.04948 5.64844 4.14844C5.54948 4.2474 5.5 4.36458 5.5 4.5V15.5C5.5 15.6354 5.54948 15.7526 5.64844 15.8516C5.7474 15.9505 5.86458 16 6 16H14C14.1354 16 14.2526 15.9505 14.3516 15.8516C14.4505 15.7526 14.5 15.6354 14.5 15.5ZM11.5 2.25C11.5 2.08333 11.4167 2 11.25 2H8.75C8.58333 2 8.5 2.08333 8.5 2.25C8.5 2.41667 8.58333 2.5 8.75 2.5H11.25C11.4167 2.5 11.5 2.41667 11.5 2.25ZM16 2V18C16 18.5417 15.8021 19.0104 15.4062 19.4062C15.0104 19.8021 14.5417 20 14 20H6C5.45833 20 4.98958 19.8021 4.59375 19.4062C4.19792 19.0104 4 18.5417 4 18V2C4 1.45833 4.19792 0.989583 4.59375 0.59375C4.98958 0.197917 5.45833 0 6 0H14C14.5417 0 15.0104 0.197917 15.4062 0.59375C15.8021 0.989583 16 1.45833 16 2Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'MobileSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
